import { Cars } from '@/core/domain/cars/models/cars.model';
import { CarsRepository } from '@/core/domain/cars/repositories/cars.repository';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CarsImplRepository extends CarsRepository {
    override getCars(): Observable<Cars> {
        const car: Cars = {
            type: 'SUCCESS',
            action: 'CONTINUE',
            notifications: [],
            data: {
                category: [
                    {
                        type: 'small',
                        cars: [
                            {
                                title: 'Fullsize',
                                model: 'Chevrolet Aveo o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 4,
                                image: 'https://trademx-cdn-dev.gruposti.dev/assets/images/fullsize.png',
                            },
                        ],
                    },
                    {
                        type: 'medium',
                        cars: [
                            {
                                title: 'Intermedio',
                                model: 'Nissan Versa o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 2,
                                image: 'https://trademx-cdn-dev.gruposti.dev/assets/images/intermedio.png',
                            },
                        ],
                    },
                    {
                        type: 'truck',
                        cars: [
                            {
                                title: 'SUV',
                                model: 'Nissan X-Trail o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 3,
                                image: 'https://clico.com.mx/Alamo/suv.png',
                            },
                        ],
                    },
                ],
            },
        };

        return of(car);
    }

    override getMoreCars(): Observable<Cars> {
        const car: Cars = {
            type: 'SUCCESS',
            action: 'CONTINUE',
            notifications: [],
            data: {
                category: [
                    {
                        type: 'small',
                        cars: [
                            {
                                title: 'Compacto Automático',
                                model: 'Chevrolet Aveo o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 4,
                                image: 'aveo-1328.png',
                            },
                            {
                                title: 'Económico Automático',
                                model: 'Nissan March o similar',
                                transmission: 'AT',
                                passenger: 4,
                                baggage: 3,
                                image: 'march-1327.png',
                            },
                            {
                                title: 'Mini Atm.',
                                model: 'Nissan March o similar',
                                transmission: 'AT',
                                passenger: 4,
                                baggage: 2,
                                image: 'march-1323.png',
                            },
                        ],
                    },
                    {
                        type: 'medium',
                        cars: [
                            {
                                title: 'Fullsize Automático',
                                model: 'VW Jetta o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 5,
                                image: 'jetta-1335.png',
                            },
                            {
                                title: 'Intermedio Aut',
                                model: 'Nissan Versa o similar',
                                transmission: 'AT',
                                passenger: 4,
                                baggage: 4,
                                image: 'versa-1330.png',
                            },
                            {
                                title: 'Intermedio Automático',
                                model: 'Nissan Versa o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 2,
                                image: 'versa-1331.png',
                            },
                            {
                                title: 'Midsize Atm.',
                                model: 'Chevrolet Aveo o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 2,
                                image: 'aveo-1329.png',
                            },
                            {
                                title: 'Premium Automático',
                                model: 'VW Passat o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 5,
                                image: 'passat-1337.png',
                            },
                            {
                                title: 'Standard Automático',
                                model: 'Chevrolet Cavalier o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 2,
                                image: 'cavalier-1333.png',
                            },
                        ],
                    },
                    {
                        type: 'family',
                        cars: [
                            {
                                title: 'Compact SUV',
                                model: 'VW T-Cross o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 4,
                                image: 't-cross-1464.png',
                            },
                            {
                                title: 'Minivan Automático',
                                model: 'Dodge Grand Caravan',
                                transmission: 'AT',
                                passenger: 7,
                                baggage: 5,
                                image: 'grandcaravan-1340.png',
                            },
                        ],
                    },
                    {
                        type: 'truck',
                        cars: [
                            {
                                title: 'Fullsize Van Manual',
                                model: 'Nissan Urvan',
                                transmission: 'SD',
                                passenger: 15,
                                baggage: 7,
                                image: 'urvan-1341.png',
                            },
                            {
                                title: 'Pick Up',
                                model: 'Toyota Hilux',
                                transmission: 'SD',
                                passenger: 5,
                                baggage: 6,
                                image: 'hilux-1342.png',
                            },
                            {
                                title: 'SUV',
                                model: 'Nissan X-Trail o similar',
                                transmission: 'AT',
                                passenger: 5,
                                baggage: 3,
                                image: 'xtrail-1339.png',
                            },
                        ],
                    },
                ],
            },
        };

        return of(car);
    }
}
